module.exports = __webpack_public_path__ + "assets/cta-decoration-tr.2d94f658.png";